import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id DDEB98E7-E016-44CA-8DE7-A31969C2CC04
 * name minus-circle
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/minus-circle.svg
 * tags
 * - Transportation + Road 
 * - Medical / Hospital 
 * - Form 
 */
export const MinusCircleIcon = createSvgIcon(<><path d="M17,13H7V11H17M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" /></>, 'MinusCircleIcon');
export default MinusCircleIcon